import React from "react";
import { object, bool, string, func } from "prop-types";
import assetify from "@quintype/framework/assetify";
import { Link, ResponsiveImage } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import LoadMoreAuthorStories from "./load-more-authors";
import Icon from "../../icons";
import Stories2AdWithLoadMore from "../../rows/Stories2AdWithLoadMore";
import authorDefault from "./author_default.svg";
import { NotFoundPage } from "../not-found/index";

import "./author.m.css";

const AuthorPageBase = ({ data, config, publisherAttributes }) => {
  const { stories, totalCount } = data;
  const { author } = data.author;
  const authorImg = author["avatar-s3-key"] || author["avatar-url"];
  const NO_OF_STORIES_TO_LOAD = 6;
  const facebookHandle = get(author, ["metadata", "Facebook"], null);
  const emailAddress = get(author, ["metadata", "Author Contact Email"], null);

  if (totalCount === 0) {
    return <NotFoundPage />;
  }

  return (
    <React.Fragment>
      <div styleName="author-page-wrapper">
        <div styleName="wrapper">
          <div styleName="content">
            <Headline text={author.name} headerLevel={1} headlineType={38} className="title" />
            {author.bio && (
              <span className={`sub-title ${publisherAttributes.lang === "en" ? "en-sub-title" : ""}`}>
                {author.bio}
              </span>
            )}
            <div styleName="icon-wrapper">
              {facebookHandle && (
                <Link href={`https://www.facebook.com/${facebookHandle}`} className="social-icon">
                  <Icon type="fb-whitebg" className="fb-whitebg" />
                </Link>
              )}
              {author["twitter-handle"] && (
                <Link href={`https://www.twitter.com/${author["twitter-handle"]}`} className="social-icon">
                  <Icon type="twitter-whitebg" className="twitter-whitebg" />
                </Link>
              )}
              {emailAddress && (
                <Link href={`mailto:${emailAddress}`} className="social-icon">
                  <Icon type="envelope" className="envelope" />
                </Link>
              )}
            </div>
          </div>
          <div styleName="picture-wrapper">
            {authorImg ? (
              author["avatar-s3-key"] ? (
                <ResponsiveImage
                  slug={author["avatar-s3-key"]}
                  aspectRatio={[1, 1]}
                  defaultWidth={200}
                  widths={[200]}
                  imgParams={{ auto: ["format", "compress"] }}
                  styleName="picture"
                  alt={author.name}
                />
              ) : (
                <img styleName="picture" src={author["avatar-url"]} alt={author.name} />
              )
            ) : (
              <img styleName="picture" src={`${assetify(authorDefault)}`} alt={author.name} />
            )}
          </div>
        </div>
        <div>
          <LoadMoreAuthorStories
            template={(e) => MoreCollectionStories(e, totalCount)}
            authorID={author.id}
            data={{ collection: null, stories: stories, config: config }}
            numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
            params={{ "item-type": "story" }}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

const MoreCollectionStories = ({ stories, onLoadMore, loading }, totalCount, author) => {
  return (
    <Stories2AdWithLoadMore
      list={stories}
      loading={loading}
      onLoadMore={onLoadMore}
      isMoreStories={totalCount > stories.length}
      isBorderTop={true}
    />
  );
};

AuthorPageBase.propTypes = {
  data: object,
  config: object,
  story: object,
  publisherAttributes: object,
};

MoreCollectionStories.propTypes = {
  stories: object,
  collection: object,
  onLoadMore: func,
  noMoreStories: string,
  config: object,
  loading: bool,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

const AuthorPage = connect(mapStateToProps, null)(AuthorPageBase);

export { AuthorPage };
